import { render, staticRenderFns } from "./ActivationDisclaimersSection.vue?vue&type=template&id=959817e8&scoped=true"
import script from "./ActivationDisclaimersSection.vue?vue&type=script&lang=js"
export * from "./ActivationDisclaimersSection.vue?vue&type=script&lang=js"
import style0 from "./ActivationDisclaimersSection.vue?vue&type=style&index=0&id=959817e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "959817e8",
  null
  
)

export default component.exports